import { tv, type VariantProps } from "../../../util/tv";

export const contentImageVariant = tv({
  slots: {
    base: ["relative", "pb-12", "overflow-hidden"],
    wrapper: ["container-fluid", "w-full", "flex flex-col lg:flex-row gap-5"],
    content: [
      "w-full lg:w-1/2",
      "flex flex-col gap-6 justify-between items-start",
      "bg-[#171C22]",
      "border-b border-t border-[#FCFCFD]/10 rounded-2xl",
      "p-8",
      "sm:p-12",
      "sm:gap-24",
      "lg:w-1/2",
      "lg:p-20.5",
    ],
    preTitle: ["mb-3"],
    title: ["max-w-2xl", "mb-8"],
    description: [],
    imageWrapper: ["grow", "w-full lg:w-1/2 aspect-square"],
    figure: ["relative", "overflow-hidden"],
    image: ["object-cover", "rounded-2xl", "overflow-hidden"],
    value: [],
    label: [],
    link: ["rounded-full"],
  },
  variants: {
    theme: {
      dark: {
        base: ["bg-black"],
        title: ["text-blue-300"],
        description: ["text-gray-60"],
        link: ["text-white"],
      },
      light: {
        base: ["bg-white"],
        title: ["text-blue-100"],
        description: ["text-gray-60"],
        link: ["text-gray-60"],
      },
    },
  },
  defaultVariants: {
    theme: "dark",
  },
});

export type ContentImageVariantProps = VariantProps<typeof contentImageVariant>;

export type ContentImageReturnVariantProps = ReturnType<
  typeof contentImageVariant
>;
